import { AirlineRating, AirlineStatus, ApprovalStatus, TransportationSystemType, DeviationType, DeviationWorkflowType, DeviationDetailType, DeviationRequestStatus, ClassOfTravel, FlightTime, LocationCurrentnessStatus } from 'model/business-enums';
import { EnumInfo } from 'model/platform-types';
import { ApproveType, CountryApprovalRequirement } from './swagger/ApiClient';

export abstract class GeneralEnumsApi {
  abstract getApplicationEnums(): Promise<ApplicationEnums>;
}

export interface ApplicationEnums {
  approvalStatuses: EnumInfo<ApprovalStatus>[];
  approvalTypes: EnumInfo<ApproveType>[];
  approvalRequirements: EnumInfo<CountryApprovalRequirement>[];
  airlineRatings: EnumInfo<AirlineRating>[];
  airlineStatuses: EnumInfo<AirlineStatus>[];
  classesOfTravel: EnumInfo<ClassOfTravel>[];
  deviationTypes: EnumInfo<DeviationType>[];
  deviationWorkflowTypes: EnumInfo<DeviationWorkflowType>[];
  deviationDetailTypes: EnumInfo<DeviationDetailType>[];
  deviationRequestStatuses: EnumInfo<DeviationRequestStatus>[];
  flightTimes: EnumInfo<FlightTime>[];
  locationCurrentnessStatuses: EnumInfo<LocationCurrentnessStatus>[];
  transportDataTypes: EnumInfo<TransportationSystemType>[];
}
